import client from "../client"

/**
 *
 * @param { motibellNo: string, cntNames: string[] } props
 */
export const updateMotibellDailyStatistic = async ({ motibellNo, cntNames = [] }) => {
  const response = await client.put(`/motibells/${motibellNo}/daily-statistics`, {
    cnt_names: cntNames,
  })

  return response.data
}
